import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {HOSTNAME} from "../../configs/Domain";
import {getAuthHeader} from "../utils";
// Async thunk for listing collections (either users or portfolios)
export const listCollections = createAsyncThunk(
  'superuser/listCollections',
  async (attr, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/super/list/${attr}`);
      if (!response.ok) throw new Error('Network response was not ok');
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async thunk for removing a portfolio from a user
export const removeUserPortfolio = createAsyncThunk(
  'superuser/removeUserPortfolio',
  async ({ uid, id }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/super/user/portfolios/remove`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ uid, id }),
      });
      if (!response.ok) throw new Error('Network response was not ok');
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async thunk for adding a portfolio to a user
export const addUserPortfolio = createAsyncThunk(
  'superuser/addUserPortfolio',
  async ({ uid, id, type }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/super/user/portfolios/add`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ uid, id, type }),
      });
      if (!response.ok) throw new Error('Network response was not ok');
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Async thunk for listing portfolios for a user
export const listUserPortfolios = createAsyncThunk(
  'superuser/listUserPortfolios',
  async (uid, { rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/super/user/portfolios/list/${uid}`);
      if (!response.ok) throw new Error('Network response was not ok');
      const portfolios = await response.json();
      return { uid, portfolios }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const impersonateAndUpdateUser = createAsyncThunk(
    'superuser/impersonateAndUpdateUser',
    async ({ userId, updateQuery }, { rejectWithValue }) => {
        try {
            const headers = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userId}`
                },
                body: JSON.stringify(updateQuery)
            };
            const response = await fetch(`${HOSTNAME}/user/update`, headers);
            if (!response.ok) throw new Error('Network response was not ok');
            return await response.json();
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


const initialState = {
  collections: [],
  userList: [],
  portfolioList: [], // {id: uuid4, name: <strin>, type: <string> }
  userPortfolios: {},
  status: 'idle',
  error: null,
};

const superuserSlice = createSlice({
  name: 'superuser',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle listCollections
      .addCase(listCollections.pending, (state) => {
        state.status = 'loading';
      })
     .addCase(listCollections.fulfilled, (state, action) => {
      state.status = 'succeeded';
      // Determine type of collection fetched and update appropriate state
      if (action.meta.arg === 'users') {
        state.userList = action.payload;
      } else if (action.meta.arg === 'portfolios') {
        state.portfolioList = action.payload;
      }
    })
    .addCase(listCollections.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.payload;
    })
      .addCase(listUserPortfolios.fulfilled, (state, action) => {
        const { uid, portfolios } = action.payload; // Ensure your API returns the uid too
        state.userPortfolios[uid] = portfolios;
      })
      // Handle removeUserPortfolio
      .addCase(removeUserPortfolio.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Update your state based on the action if needed
      })
        .addCase(impersonateAndUpdateUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(impersonateAndUpdateUser.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Optionally update user data or confirm the update
      })
      .addCase(impersonateAndUpdateUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default superuserSlice.reducer;
